module.exports = __webpack_public_path__ + "img/slide-14.c60f03af.jpeg";